// extracted by mini-css-extract-plugin
module.exports = {"pg-plan__filter":"styles_pg-plan__filter__-bLoV","pg-plan__filter__actions":"styles_pg-plan__filter__actions__QUp1g","pg-plan__table":"styles_pg-plan__table__aPTYG"};